import React, { useState } from "react";
import { useContextSelector } from "use-context-selector";
import { isNumber } from "lodash";
import BetSlipContext from "../../../context/BetSlipContext";
import { formatWithCommas } from "../../../Utils/Toast";
import useScrollToItem from "../../../component/Scroll";
import RenderOddsVelkie from "./RenderOddsVelkie";
import useSelectionLogic from "../../useLogic/useSelectionLogic";

const SelectionVelkie = ({
  runner,
  backOdds,
  layOdds,
  oldBack,
  oldLay,
  profileData,
  marketName,
  detail,
  ms,
  position,
  typeGame,
  user,
  marketId,
  totalMatched,
}) => {
  const showBetDialog = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.showBetDialog;
  });

  const betSlipObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.betSlipObject;
  });

  const [localLimit, setLocalLimit] = useState({});
  const scrollToItem = useScrollToItem("#header"); // Pass header selector
  const { handelChange, checkArrays } = useSelectionLogic({
    user: user,
    profileData: profileData,
    detail: detail,
    typeGame: typeGame,
    marketId: marketId,
    totalMatched: totalMatched,
    setLocalLimit,
    scrollToItem,
    localLimit,
    marketName,
  });

  return (
    <div className="-mx-2 py-2 px-2 bg-white">
      <div className="mt-3px mb-1 flex justify-between items-center">
        <div className="w-9/12" />
        <div className="w-4/12 grid gap-0.5 grid-cols-2">
          <div className="min-w-min text-10 text-global-font-on-light text-center">
            Back
          </div>
          <div className="min-w-min text-10 text-global-font-on-light text-center">
            Lay
          </div>
        </div>
      </div>
      <div>
        <div className="relative">
          <div className="space-y-px">
            {runner?.map((item, index) => {
              const odds_back = backOdds?.filter(
                (todd) => todd.ri === item.SelectionId
              );
              const odds_lay = layOdds?.filter(
                (todd) => todd.ri === item.SelectionId
              );
              const old_back = oldBack?.filter(
                (todd) => todd.ri === item.SelectionId
              );
              const old_lay = oldLay?.filter(
                (todd) => todd.ri === item.SelectionId
              );
              let disabelBack =
                "lockBackBets" in item ? item?.lockBackBets : false;
              let disabelLay =
                "lockLayBets" in item ? item?.lockLayBets : false;
              let disableFull = checkArrays(
                odds_back?.slice(0, 1),
                odds_lay?.slice(0, 1),
                localLimit
              );
              let showPosition =
                (isNumber(item?.position) &&
                  position?.length > 0 &&
                  Math.abs(item?.position) > 0) ||
                (Math.abs(item?.newPosition) >= 0 &&
                  showBetDialog &&
                  betSlipObject?.playType == typeGame &&
                  marketId == betSlipObject?.object?.newMarketId);
              return (
                <div className="exchange_panel_line">
                  <div className="flex justify-start items-center bg-black-100">
                    <h2 className="px-2.5 w-9/12 h-full leading-5 text-13 flex flex-col justify-center break-all">
                      {item?.RunnerName || item?.runnerName}
                      {showPosition && (
                        <div
                          className="text-10 leading-normal flex"
                          data-testid="forecast"
                        >
                          {" "}
                          {isNumber(item?.position) &&
                            position?.length > 0 &&
                            Math.abs(item?.position) > 0 && (
                              <span
                                className={`flex items-center ${
                                  item?.position > 0
                                    ? "text-success"
                                    : "text-error"
                                } `}
                              >
                                {isNumber(item?.position) &&
                                Math.abs(item?.position) > 0
                                  ? item?.position > 0
                                    ? Math?.abs(item?.position).toFixed(2)
                                    : `(${Math.abs(item?.position).toFixed(2)})`
                                  : ""}
                              </span>
                            )}
                          {Math.abs(item?.newPosition) >= 0 &&
                            showBetDialog &&
                            betSlipObject?.playType == typeGame &&
                            marketId == betSlipObject?.object?.newMarketId && (
                              <span
                                className={`flex items-center ${
                                  item?.newPosition > 0
                                    ? "text-success"
                                    : "text-error"
                                } `}
                              >
                                <div className="icon-arrow-left rotate-180 flex text-6 mx-0.5" />{" "}
                                {item?.newPosition > 0
                                  ? Math.abs(item?.newPosition).toFixed(2)
                                  : `(${Math.abs(item?.newPosition).toFixed(
                                      2
                                    )})`}
                              </span>
                            )}
                        </div>
                      )}
                    </h2>
                    <RenderOddsVelkie
                      component={"betfair"}
                      index={index}
                      item={item}
                      disabelBack={disabelBack}
                      oldBack={old_back}
                      oldLay={old_lay}
                      disableFull={disableFull}
                      disabelLay={detail?.market == "Win" ? true : disabelLay}
                      isInPlay={
                        ["Win", "Winner"].includes(detail?.market)
                          ? true
                          : detail?.status == "in_play"
                          ? true
                          : false
                      }
                      handelChange={handelChange}
                      odds_lay={odds_lay}
                      odds_back={odds_back}
                      limit={localLimit}
                      ms={ms}
                      betType={betSlipObject?.betType}
                      active={
                        showBetDialog &&
                        marketId == betSlipObject?.newMarketId &&
                        item?.SelectionId ==
                          betSlipObject?.object?.SelectionId &&
                        typeGame == betSlipObject?.playType
                      }
                    />
                  </div>
                </div>
              );
            })}
            {ms != 1 && (
              <div data-v-d884c596>
                <div
                  data-v-d884c596
                  className="absolute right-0 top-0 flex justify-center items-center h-full bg-black-700 opacity-80 text-11 text-white rounded-md w-31%"
                >
                  Suspend
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="pt-1 flex justify-between items-center">
          <div className="inline-flex justify-center items-center rounded bg-secondary text-global-font-on-dark px-3px py-1.5">
            <i className="pl-3px pr-0.5 icon-graph" />
            <span className="px-3px text-11"> Market Depth </span>
          </div>
          <div
            className="flex items-center text-black-600"
            data-testid="betLimit"
          >
            <i className="px-1 mt-0.5 text-14 icon-min-max" />
            <span className="px-0.5 text-11">min/max</span>
            <span className="px-1 text-11 font-bold">
              {formatWithCommas(localLimit?.minAmount)}/
              {formatWithCommas(localLimit?.maxAmount)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(SelectionVelkie);
